<template>
  <layout>
    <div style="margin:55px auto">
      <div class="description-calculator">
        <transition-group mode="out-in" name="slide-fade" tag="div">
          <div
            class="outlined-primary text-primary"
            v-for="item in type === 'Lease' ? lease : ''"
            :key="item.id"
          >
            <i class="fas fa-info"></i>
            <span style="margin-right:5px">{{item.val}}:</span>
            <span :key="Math.random(0,50000000000)">{{item.name}}</span>
          </div>
        </transition-group>
      </div>
      <q-card>
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs">
            <div style="width:100%;max-width:600px">
              <transition name="slide-fade">
                <auto-calculate></auto-calculate>
              </transition>
            </div>
          </div>
        </div>
      </q-card>
      <transition name="slide-fade">
        <calculate-result></calculate-result>
      </transition>
      <transition name="slide-fade">
        <detailed-calculate-result :type="type"></detailed-calculate-result>
      </transition>
    </div>
  </layout>
</template>


<script>
import CalculateResult from "../components/CalculateResult";
import DetailedCalculateResult from "../components/DetailedCalculateResult";
import Layout from "../components/Layout";
import AutoCalculate from "../components/AutoCalculate";
export default {
  metaInfo() {
    return {
      title: "Finance calculator with different options. | FMS",
      // title: "FMS - Build your network in your field of interest",
      meta: [
        {
          name: "description",
          // "FMS is about connecting in your field of interest. Our vision is to help people share their knowledge, work, projects, papers and ideas and build their network through what they do rather where they live, study or work.",
          content:''
        },
        {
          property: "og:title",
          content: "Finance calculator with different options. | FMS",
        },
        { property: "og:site_name", content: "FMS" },
        { property: "og:type", content: "website" },
        { name: "robots", content: "index,follow" },
      ],
    };
  },
  components: {
    DetailedCalculateResult,
    CalculateResult,
    AutoCalculate,
    Layout,
  },
  data() {
    return {
      lease: [
        {
          val: "Method 1",
          name: "If you know Monthly Dep $ Amount",
          id: 1,
        },
        {
          val: "Method 2",
          name: "İf you know Monthly Dep % Amount",
          id: 2,
        },
      ],
      finance: [
        {
          val: "Method 1",
          name: "If Finance is straight Forward till balance gets $0",
          id: 3,
        },
        {
          val: "Method 2",
          name: "If Finance is only certain period of time for certain %",
          id: 4,
        },
      ],
    };
  },
  computed: {
    method() {
      return this.$store.state.calculator.method;
    },
    type() {
      return this.$store.state.calculator.type;
    },
  },
  watch:{
    method(n,o){
      this.$store.commit('calculator/SET_SHOW',false)
    },
    type(n,o){
      this.$store.commit('calculator/SET_SHOW',false)
      
    }
  }
};
</script>

<style lang="scss">
.outlined-primary {
  border: 1px solid #027be3;
}
.description-calculator {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  div {
    flex: 1;
    div {
      padding: 5px 15px;
      flex: 1;
      border-radius: 5px;
      margin-bottom: 5px;
      background: #fff;
      span {
        flex: 1;
      }
      i {
        margin-right: 5px;
      }
    }
  }
}
</style>